import React, { ReactNode, createContext } from 'react'

import { ObservationState } from '../types'

import { ObservationContextProps, initialContextState, useObservationEditor } from './ObservationState'

export const ObservationContext = createContext<ObservationContextProps>(initialContextState)

interface Props {
  children: ReactNode
  state: ObservationState
}

export const ObservationProvider = ({ children, state: initialState }: Props) => {
  return (
    <ObservationContext.Provider value={useObservationEditor(initialState)}>
      {children}
    </ObservationContext.Provider>
  )
}
